var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39758 16C2.07742 16 1.81787 15.7357 1.81787 15.4097V0.590319C1.81787 0.264295 2.07742 0 2.39758 0C2.71775 0 2.97729 0.264295 2.97729 0.590319V15.4097C2.97729 15.7357 2.71775 16 2.39758 16Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0226 15.4097C13.0226 15.7357 13.2822 16 13.6023 16C13.9225 16 14.182 15.7357 14.182 15.4097V0.590319C14.182 0.264295 13.9225 0 13.6023 0C13.2822 0 13.0226 0.264295 13.0226 0.590319V15.4097ZM0.57971 12.68H4.21565C4.53582 12.68 4.79536 12.4158 4.79536 12.0897C4.79536 11.7637 4.53582 11.4994 4.21565 11.4994H0.57971C0.259545 11.4994 0 11.7637 0 12.0897C0 12.4158 0.259545 12.68 0.57971 12.68Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42041 15.4097C7.42041 15.7357 7.67996 16 8.00012 16C8.32029 16 8.57983 15.7357 8.57983 15.4097V0.590319C8.57983 0.264295 8.32029 0 8.00012 0C7.67996 0 7.42041 0.264295 7.42041 0.590319V15.4097ZM11.7845 12.68H15.4204C15.7406 12.68 16.0001 12.4158 16.0001 12.0897C16.0001 11.7637 15.7406 11.4994 15.4204 11.4994H11.7845C11.4643 11.4994 11.2048 11.7637 11.2048 12.0897C11.2048 12.4158 11.4643 12.68 11.7845 12.68Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81819 4.50046H6.18225C5.86208 4.50046 5.60254 4.23617 5.60254 3.91014C5.60254 3.58412 5.86208 3.31982 6.18225 3.31982H9.81819C10.1384 3.31982 10.3979 3.58412 10.3979 3.91014C10.3979 4.23617 10.1384 4.50046 9.81819 4.50046Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.6f9966594b53ea4589ee1d660fb9f45f.svg";
export { ForwardRef as ReactComponent };